<template>
  <div class="checkout-content-block">
    <div class="checkout">
      <b-row>
        <template v-for="(block,key) in checkout_blocks">
          <component
            v-if="block.show"
            :key="_uid+block+key"
            :is="block.key"
            :solution="solution"
          />
        </template>
      </b-row>
    </div>
  </div>

</template>

<script>
import Hotel from '@liveeps/components/blocks/hotel'
import Reservation from '@liveeps/components/blocks/reservation'
import Accommodations from '@liveeps/components/blocks/accommodations'
import Informations from "@liveeps/components/blocks/informations"

export default {
  name: 'checkout-content-block',

  components: {
    'hotel': Hotel,
    'reservation': Reservation,
    'accommodations': Accommodations,
    'informations': Informations,
  },

  props: {
    solution: Object,
  },

  data() {
    return {
      checkout_blocks: [],
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
    this.checkout_blocks = [
      {
        key: "hotel",
        show: true,
      },
      {
        key: "reservation",
        show: true,
      },
      {
        key: "accommodations",
        show: true,
      },
      {
        key: "informations",
        show: true,
      }
    ]
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>
</style>